import DOMPurify from "dompurify";

export const sanitizeInput = (input: string): string => {
  if (!input) return input;

  const config = {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
    ALLOW_DATA_ATTR: false,
    ALLOW_UNKNOWN_PROTOCOLS: false,
    SANITIZE_DOM: true,
    SANITIZE_NAMED_PROPS: true,
    FORBID_ATTR: ["style", "onerror", "onload", "onclick", "onmouseover"],
    FORBID_TAGS: ["script", "object", "embed", "link", "style", "img", "svg"],
  };

  let sanitized = DOMPurify.sanitize(input, config);

  sanitized = sanitized
    .replace(/javascript:/gi, "")
    .replace(/data\s*:/gi, "")
    .replace(/vbscript:/gi, "")
    .replace(/\s+/g, " ");

  return sanitized;
};

export const containsDangerousContent = (input: string): boolean => {
  if (!input) return false;

  const dangerousPatterns = [
    /<script/i,
    /<\/script>/i,
    /javascript:/i,
    /on\w+\s*=/i,
    /data\s*:/i,
    /vbscript:/i,
    /expression\s*\(/i,
    /&#/i,
    /eval\s*\(/i,
    /alert\s*\(/i,
    /confirm\s*\(/i,
    /prompt\s*\(/i,
    /document\./i,
    /window\./i,
    /<iframe/i,
    /<object/i,
    /<embed/i,
    /<link/i,
    /<meta/i,
    /<img[^>]*onerror/i,
    /'\s*(or|and)\s*'/i,
    /union\s+select/i,
    /drop\s+table/i,
  ];

  return dangerousPatterns.some((pattern) => pattern.test(input));
};

export const isInputSafe = (input: string): boolean => {
  if (!input) return true;

  if (containsDangerousContent(input)) return false;

  const sanitized = sanitizeInput(input);
  return sanitized === input;
};
